import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto flex min-h-[70vh] w-full max-w-[720px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="font-heading text-[100px] font-extrabold leading-none tracking-tight text-background-200 md:text-[140px]">
        404
      </span>
      <span className="-mt-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
        <i className="ri-emotion-sad-line text-2xl" />
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950">
        页面不存在或已下线
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的页面可能已被移除或链接有误，返回首页继续浏览精彩赛事。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/schedule"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-400 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-calendar-schedule-line" />
          查看赛程
        </Link>
      </div>
    </section>
  );
}